import { useEffect, useState } from "react";
import { systemJobsApi } from "../services/systemJobsApi";

const POLL_INTERVAL_MS = 60_000;

/** Live count of background jobs currently in a FAILED state - mirrors
 * useActionCenterCount's polling pattern exactly (same interval, same "no push, just poll"
 * tradeoff is fine for an internal ops indicator). Never carries error detail, only a count. */
export function useSystemJobsFailureCount(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const fetchCount = () => {
      systemJobsApi.failureCount().then((r) => {
        if (!cancelled) setCount(r.data.count);
      }).catch(() => {});
    };
    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, [enabled]);

  return count;
}
